export default __webpack_public_path__ + "static/media/bjliguria.5ee6b083.png";